import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app-services/config/config.app';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { Enums } from '../../enums/enums';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { ServiceCampaignInsights } from './campaign-insights.service';
import { MockServiceCampaignInsights } from './campaign-insights.service.mock';

export function FactoryServiceCampaignInsights(http: HttpClient, endpoints: AbstractEndpoints, appMonitoring: AppMonitoring, appConfig: AppConfig) {
    appMonitoring.logEvent('FactoryServiceCampaignInsights', 'Campaign Insights Service Factory loaded');
    switch (appConfig.environment) {
        case Enums.Environments.MockData:
        case Enums.Environments.MockDataWithAuth:
            return new  MockServiceCampaignInsights(endpoints, http);
        default:
            return new ServiceCampaignInsights(endpoints, http, appConfig)
    }
}
